var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('h1',[_vm._v(" "+_vm._s(_vm.schemeDetails.company)+" Pension Scheme – My Retirement Planner")]),_c('div',{staticClass:"copyright"},[_vm._v("LCP LLP "+_vm._s(new Date().getFullYear()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }